/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_NewInputs */

const en_whats_new_new = /** @type {(inputs: Whats_New_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const de_whats_new_new = /** @type {(inputs: Whats_New_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Whats_New_NewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_new = /** @type {((inputs?: Whats_New_NewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_NewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_whats_new_new(inputs)
	return en_whats_new_new(inputs)
});